<template lang="html">
  <div class="basic_controls">
    <button
      v-shortkey="['meta', 'enter']"
      @shortkey="$store.dispatch('previewActiveShow')"
      @click="$store.dispatch('previewActiveShow')"
    >
      Preview
    </button>
    |
    <button @click="$emit('timelineThumbSmaller')">TL -</button>
    <button @click="$emit('timelineThumbLarger')">TL +</button>
    |
    <button @click="$emit('gridThumbSmaller')">Grid -</button>
    <button @click="$emit('gridThumbLarger')">Grid +</button>
    |
    <button @click="$emit('zoomIn')">zoomIn</button>
    <button @click="$emit('zoomOut')">zoomOut</button>
    |
    <button @click="$emit('rewind')">Rewind</button>
    <button
      v-shortkey="['space']"
      @shortkey="$emit('playToggle')"
      @click="$emit('playToggle')"
    >
      Play/Pause
    </button>

    <div v-show="false">
      <!-- These are hidden, but necessary for shortkeys -->
      <p v-for="(item, idx) in items" :key="'shortkey' + idx">
        <button
          v-shortkey="item.shortkey"
          @shortkey="$emit(item.emitter)"
          @click="$emit(item.emitter)"
        >
          {{ item.emitter }}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      items:[
        {shortkey: ['arrowleft'], emitter: 'scrubRewind'},
        {shortkey: ['arrowright'], emitter: 'scrubForward'},
        {shortkey: ['j'], emitter: 'scrubRewind'},
        {shortkey: ['k'], emitter: 'scrubForward'},
        {shortkey: ['meta', '='], emitter: 'zoomIn'},
        {shortkey: ['meta', '-'], emitter: 'zoomOut'},
        {shortkey: ['1'], emitter: 'gridToggle'}
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_controls{
  position: absolute;
  bottom: 16px;
  left: 30%;
  z-index: 200;
}
</style>
